import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { DrawerContext } from "context/DrawerContext";

const listItemTextSx = {
  "& .MuiListItemText-primary": { color: "text.primary" },
  "& .MuiListItemText-secondary": { color: "text.secondary" },
};

const NavListItem = ({
  icon,
  text,
  secondary,
  link,
  onClick,
  disabled,
  noSelect,
  matchPathPrefix,
  nested,
  sx,
}) => {
  const open = useContext(DrawerContext);
  const { pathname } = useLocation();
  let external = false;
  if (link) {
    const pattern = /^((http|https):\/\/)/;
    external = pattern.test(link);
  }

  // Active when the path matches the link exactly, or (with matchPathPrefix)
  // when it sits under the link as a sub-route.
  const selected =
    noSelect || !link
      ? false
      : pathname === link ||
        (matchPathPrefix && !external && pathname.startsWith(`${link}/`));

  const inner = (
    <>
      <ListItemIcon
        sx={[
          { minWidth: 0, justifyContent: "center" },
          open ? { mr: 3 } : { mr: "auto" },
        ]}
      >
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={text}
        secondary={secondary}
        sx={[{ opacity: open ? 1 : 0 }, listItemTextSx]}
      />
    </>
  );

  const item = (
    <ListItem disablePadding onClick={onClick} disabled={disabled} sx={{ display: "block", ...sx }}>
      {onClick || link ? (
        <ListItemButton
          selected={selected}
          sx={[
            // Indent nested (sub-menu) content only while expanded; the button
            // itself still spans full width so its background reaches the edge.
            { minHeight: 48, pr: 2.5, pl: nested && open ? 5 : 2.5 },
            open ? { justifyContent: "initial" } : { justifyContent: "center" },
          ]}
        >
          {inner}
        </ListItemButton>
      ) : (
        inner
      )}
    </ListItem>
  );

  // Internal link — inherit color so global `a { color: … }` does not override nav labels.
  if (link && !external) {
    return (
      <Link to={link} style={{ color: "inherit", textDecoration: "none" }}>
        {item}
      </Link>
    );
  }

  // External link
  if (link && external)
    return (
      <Link to={link} target="_blank" rel="noreferrer">
        {item}
      </Link>
    );

  return item;
};

export default NavListItem;
